<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col cols="4">
        <app-select-mapeamento
          :mapeamento="mapeamento"
          :mapeamentos="mapeamentos"
          @return="(value) => (mapeamento = value)"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card-widget title="Informações">
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col cols="6">
                <span class="font-weight-bold">Mapeamento: </span>
                <span class="font-weight-light">{{
                  mapeamento && mapeamento.nome ? mapeamento.nome : ""
                }}</span>
              </v-col>
              <v-col
                v-if="inicio && fim"
                cols="6"
              >
                <span class="font-weight-bold">Período: </span>
                <span
                  class="font-weight-light"
                >{{ inicio | date }} até {{ fim | date }}</span>
              </v-col>
            </v-row>
            <v-row
              v-if="acesso !== 'COMISSAO'"
              no-gutters
            >
              <v-col
                v-if="servidor && chefia"
                cols="6"
              >
                <span class="font-weight-bold">Gestor(a): </span>
                <span class="font-weight-light">{{ servidor }}</span>
              </v-col>
              <v-col
                v-else-if="servidor"
                cols="6"
              >
                <span class="font-weight-bold">Servidor(a): </span>
                <span class="font-weight-light">{{ servidor }}</span>
              </v-col>
              <v-col
                v-if="unidade && unidade.sigla"
                cols="6"
              >
                <span class="font-weight-bold">Unidade: </span>
                <span
                  class="font-weight-light"
                >{{ unidade.sigla }} - {{ unidade.nome }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-widget
          :enable-actions="!prazoEsgotado && !prazoFuturo"
          :title="titulo ? titulo : 'Formulário'"
        >
          <div slot="widget-content">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  absolute
                  color="secondary"
                  dark
                  fab
                  right
                  top
                  @click="loadTutorial"
                  v-on="on"
                >
                  <v-icon>help</v-icon>
                </v-btn>
              </template>
              <span>Em caso de dúvidas, clique aqui</span>
            </v-tooltip>
            <v-row
              v-if="
                prazoEsgotado &&
                  usuarioMapeamento &&
                  usuarioMapeamento.tipo == 'REGULAR'
              "
              no-gutters
            >
              <v-col>
                <app-alert
                  icon="watch_later"
                  message="O prazo para participação está esgotado. Obrigado pela sua colaboração."
                  type="warning"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="
                prazoFuturo &&
                  usuarioMapeamento &&
                  usuarioMapeamento.tipo == 'REGULAR'
              "
              no-gutters
            >
              <v-col>
                <app-alert
                  icon="watch_later"
                  message="O prazo para participação ainda não está disponível."
                  type="info"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="!mapeamento"
              no-gutters
            >
              <v-col>
                <app-alert
                  message="Não há nenhum mapeamento disponível para realização da dinâmica."
                  type="warning"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <!-- Slot Body -->
                <slot name="body" />
              </v-col>
            </v-row>
          </div>
          <div
            v-if="!prazoEsgotado && !prazoFuturo"
            slot="widget-actions"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <!-- Slot Actions-->
                <slot name="actions" />
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppAlert from '@/components/core/AppAlert';
import AppSelectMapeamento from '@/components/core/AppSelectMapeamento';
import Data from '@/modules/data';

export default {
  name: 'AppMapeamento',

  components: { VCardWidget, AppAlert, AppSelectMapeamento },

  props: {
    titulo: {
      type: String,
      default: '',
    },
    inicio: {
      type: String,
      default: null,
    },
    fim: {
      type: String,
      default: null,
    },
    acesso: {
      type: String,
      default: 'COMUM',
    },
  },

  computed: {
    ...mapState({
      servidor: (state) => state.auth.usuario.nome,
      unidade: (state) => state.mapeamento.usuarioMapeamento.unidade,
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.mapeamento.usuarioMapeamento.chefia,
      subChefia: (state) => state.mapeamento.usuarioMapeamento.subChefia,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    ...mapGetters({
      getMapeamento: 'mapeamento/getMapeamento',
      getMapeamentos: 'mapeamento/getMapeamentos',
    }),
    mapeamento: {
      get() {
        return this.getMapeamento(this.acesso);
      },
      set(mapeamento) {
        const payload = { tipo: this.acesso, mapeamento };
        this.$store.dispatch('mapeamento/setMapeamento', payload);
      },
    },
    mapeamentos() {
      return this.getMapeamentos(this.acesso);
    },
    prazoEsgotado() {
      return this.fim && Data.compare('isAfter', { b: this.fim });
    },
    prazoFuturo() {
      return this.inicio && Data.compare('isBefore', { b: this.inicio });
    },
  },

  methods: {
    loadTutorial() {
      let tutorial = '';
      switch (this.$route.name) {
        case 'CadastroComportamental':
          tutorial = 'CadastroComportamental';
          break;
        case 'NormalizacaoComportamento':
          tutorial = 'NormalizacaoComportamental';
          break;
        case 'CadastroResponsabilidade':
          tutorial = 'CadastroResponsabilidade';
          break;
        case 'ValidacaoResponsabilidade':
          tutorial = 'ValidacaoResponsabilidade';
          break;
        case 'NormalizacaoResponsabilidade':
          if (this.$route.path.includes('normalizacao')) {
            tutorial = 'NormalizacaoResponsabilidade';
          } else if (this.$route.path.includes('consolidacao')) {
            tutorial = 'ConsolidacaoResponsabilidade';
          }
          break;
        default:
          tutorial = '';
      }
      this.$store.dispatch('app/showTutorial', { nome: tutorial });
    },
  },
};
</script>
